﻿import React, { useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import dayjs from 'dayjs';
import Skeleton from 'react-loading-skeleton';

import Chart from 'react-apexcharts';
import Content_Container from '@Elements/Content_Container';
import { H2 } from '@Elements/Fonts';

import { Inter_Client_Time_Chart_Props, Time_Log_Entry } from '@Util/Types';


export default function Inter_Client_Time_Chart(props: Inter_Client_Time_Chart_Props): JSX.Element {
    const [t] = useTranslation();
    const [data_loading, set_data_loading] = useState<boolean>(true);

    const chart_data = useMemo(() => {
        set_data_loading(true);
        let time_log: Time_Log_Entry[] = [];

        if (props.data_view === "day") {
            time_log = props.todays_time_log;
        } else if (props.data_view === "week") {
            time_log = props.weeks_time_log;
        } else if (props.data_view === "month") {
            time_log = props.months_time_log;
        }
    
        let customer_hours = time_log.reduce((acc, log) => {
            let minutes = dayjs(log.endDate).diff(dayjs(log.startDate), 'minute');
            let hours = minutes / 60;
    
            acc[log.customerName] = {
                hours: (acc[log.customerName]?.hours || 0) + hours,
                color: log.color
            };
    
            return acc;
        }, {});
    
        let sorted_customers = Object.keys(customer_hours).sort();
        let data = [];
        let colors = [];
    
        sorted_customers.forEach(customer => {
            data.push(customer_hours[customer].hours);
            colors.push(`rgb(${customer_hours[customer].color})`);
        });
    
        set_data_loading(false);
    
        return {
            customers: sorted_customers,
            data,
            colors
        };
    }, [props.data_view, props.todays_time_log, props.weeks_time_log, props.months_time_log]);

    return (
        <section className="Module">
            <header className="Module_Header">
                <H2>{t('Text.Customers')}</H2>
            </header>
            <Content_Container>
                {data_loading ? (
                    <Skeleton
                        width={'100%'}
                        height={270.7}
                        baseColor="#1c1e21"
                        highlightColor="#282c32"
                    />
                ) : (
                    <Chart
                        type="pie"
                        series={chart_data.data}
                        options={{
                            chart: {
                                type: 'donut'
                            },
                            colors: chart_data.colors,
                            dataLabels: {
                                enabled: true
                            },
                            legend: {
                                show: true,
                                position: "right",
                                labels: {
                                    colors: '#929292',
                                },
                            },
                            labels: chart_data.customers,
                            stroke: {
                                show: false
                            },
                            tooltip: {
                                enabled: false
                            }
                        }}
                    />
                )}
            </Content_Container>
        </section>
    )
}